import { ShenCeUrl } from '@/httpService/API';
let sensors = require('sa-sdk-javascript');
import { Storage } from './Storage';
// import { debuggerkey } from './utils';
// import { urlSearchParamsToObject } from './index';
//全埋点
export const fullBurialPoint = (params) => {
    sensors.use('PageLeave');
    // let searchObj = urlSearchParamsToObject(window.location.href);
    sensors.init({
        show_log: false,
        server_url: `${ShenCeUrl}/p/dc/sa.gif?project=grt_point`,
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'default',
            //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect',
            collect_tags: {
                div: {
                    max_level: 1 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
                },
                li: true,
                img: true,
                span: true,
                ul: true,
                p: true,
                b: true,
                header: true,
                label: true
                // ... 其他标签
            }
        }
    });
    // 注册公共属性
    if (!params.tenant_id) {
        alert('租户丢失，请刷新页面');
        return false;
    }
    sensors.registerPage({
        uid: params.uid || '',
        platform_id: 600, //学习公社6.0
        client_type: 'web',
        tenant_id: params.tenant_id,
        is_login_state: params.isLogin, //登录状态
        portal_id: params.portal_id || Storage.get('portal_id')
        // nav_id: params.nav_id || searchObj.nav_id
    });
    console.log('开启了全局埋点');
    sensors.quick('autoTrack');
};

// 注册“神策”数据埋点
export const playSensors = function (params) {
    let point_type = `${ShenCeUrl}/p/dc/sa.gif?project=grt_point&point_type=video_point`;
    // searchObj = urlSearchParamsToObject(window.location.href);
    sensors.init({
        // server_url: `${requestHost}/p/dc/sa.gif?project=grt_point&point_type=video_point`,
        server_url: point_type,
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'not_collect',
            //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect'
        }
    });
    // 注册公共属性
    // 注册公共属性
    if (!params.tenant_id) {
        alert('租户丢失，请刷新页面');
        return false;
    }
    sensors.registerPage({
        uid: params.uid || '',
        platform_id: 600, //学习公社6.0
        client_type: 'web',
        tenant_id: params.tenant_id,
        is_login_state: params.isLogin || true, //登录状态
        portal_id: params.portal_id || Storage.get('portal_id')
        // nav_id: params.nav_id || searchObj.nav_id
    });
};
//神策数据埋点传参
export const genSensorsData = function (params, paramsEvent) {
    if (paramsEvent) {
        sensors.track(paramsEvent, params);
        return false;
    }
    sensors.track('videoPlay', params);
};
//神策数据文档传参
export const genSensorsDocData = function (params, paramsEvent) {
    if (paramsEvent) {
        sensors.track(paramsEvent, params);
        return false;
    }
    sensors.track('doc_read', params);
};

// 登录埋点
export const loginBurialPoint = function (params) {
    let point_type = `${ShenCeUrl}/p/dc/sa.gif?project=grt_point&point_type=login`;
    sensors.init({
        server_url: point_type,
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'not_collect',
            //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'not_collect'
        }
    });
    // 注册公共属性
    // 注册公共属性
    if (!params.tenant_id) {
        alert('租户丢失，请刷新页面');
        return false;
    }
    sensors.registerPage({
        uid: params.uid || '',
        platform_id: 600, //学习公社6.0
        client_type: 'web',
        tenant_id: params.tenant_id,
        is_login_state: params.isLogin || true, //登录状态
        portal_id: params.portal_id || Storage.get('portal_id')
        // nav_id: params.nav_id || searchObj.nav_id
    });
    sensors.track('login', params);
};

export default {
    playSensors,
    genSensorsData
};
